/**
 * Deleting a list of data items by id from the data browser screen 
 * @param {string[]} ids - The ids of the data items to be deleted
 * @returns {Promise<string[]>} - A promise that resolves with a list of success messages
 */

import apis from "@api/api";

const handleDataItemMove = ({
  ids,
  folderId
}: {
  ids: string[];
  folderId: string;
}): Promise<string[]> => {
  return new Promise(async (resolve, reject) => {
    if (!ids || ids.length === 0 || !folderId) {
      reject(new Error('No ids provided or ids incorrect'));
      return;
    }

    try {
      const results = await Promise.all(
        ids.map(async (id) => {
          // Replace with your actual delete logic
          await apis.moveDataItem(id, folderId);
          return `Data item with id ${id} moved successfully`;
        })
      );
      resolve(results);
    } catch (error) {
      reject(new Error(`Failed to move data items: ${error.message}`));
    }
  });
};

export default handleDataItemMove;
